import moment from 'moment';
import _ from 'lodash';
import { move } from 'ramda';

class PosMovementsController {
  /* @ngInject */
  constructor($log, $rootScope, $translate, $filter, endPoints,StoreService, NewInstrumentHistoryService, MerchantDetailService, MerchantDetailActions, MerchantDetailStore, PaginationSettings, PosService, StoreStates, LoginService) {
    const that = this;

    that.loading = {
      movements: false,
      operators: false,
      store: false
    };

    that.operator = undefined;
    that.store = undefined;
    that.showDevices = false;

    that.pagination = {
      currentPage: {
        number: 0,
        data: []
      }
    };
    const date = new Date();
    that.start = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
    that.end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    that.maxDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    let movements;
    let firstLoad = true;

    const loadStores = () => {
      that.loading.store = true;
      StoreService.getStoreList().then(res => {
          that.filters.store.options = _.map(res, (store) => ({
            id: store.id,
            name: store.name
          }));
      }).finally( () => {
        that.loading.store = false;
      })
    };


    that.loadOperators = (storeId) => {
      LoginService.getMerchantProfile().then((result) => {
        that.intestazione = result.business.company;
        that.loading.operators = true;
        MerchantDetailService.getMerchantDetail(result.business.id, storeId, false).then((res) =>{
          that.loading.operators = false;
          that.showDevices = true;
          const merchantDetails = res
          that.filters.operator.options = _.map(merchantDetails, (operator) => ({
            id: operator.id,
            name: operator.deviceName
          }));
        })
      });
    };

    const loadCollectionMethods = () => {
      that.filters.method.options = [
        {
          id: "PAYPAL_PAYMENT",
          filter: "PAYPAL_WALLET",
          name: "PAYPAL WALLET",
          show: true
        },
        {
          id: "PAYPAL_CARD_PAYMENT",
          filter: "PAYPAL_CARD",
          name: "PAYPAL CARTE",
          show: true
        },
        {
            id: "PAYPAL_REFUND",
            name: "RIMBORSO PAYPAL",
            show: false
        },
        {
            id: "PAYPAL_CARD_REFUND",
            name: "RIMBORSO CARTA PAYPAL",
            show: false
        },
        {
          id: "ALIPAY_PAYMENT",
          filter: "ALIPAY",
          name: "ALIPAY+",
          show: true
        },
        {
            id: "ALIPAY_REFUND",
            name: "RIMBORSO ALIPAY+",
            show: false
        },
        {
          id: "CONNECT_MERCHANT_PAYMENT",
          filter: "ALIPAY_CONNECT",
          name: "ALIPAY+ ONLINE",
          show: true
        },
        {
            id: "CONNECT_MERCHANT_REFUND",
            name: "RIMBORSO ALIPAY+ ONLINE",
            show: false
        },
        {
          id: "TINABA",
          filter: "TINABA",
          name: "TINABA",
          show: true
        }
      ]
    }

    const processMovements = (rawMovements) => _.map(rawMovements, (movement) => ({
      pdf: false,
      direction: movement.direction == "INCOMING" ? 'in' : 'out',
      amount: movement.amount+movement.fee,
      fee: movement.fee,
      transactionId: movement.transactionId,
      date: movement.lastModifiedDate,
      shopName: movement.shopName,
      externalEventType: getExternalType(movement.externalEventType),
      walletTransactionId: movement.walletTransactionId,
      operator: {
        id: movement.merchantDeviceId,
        name: movement.merchantDeviceName
      },
      contact: {
        title: movement.title,
        name: movement.objectAlias ? movement.objectAlias : movement.message
      }
    }));

    const getExternalType = (externalEventType) => {
      if(externalEventType){
        var res = that.filters.method.options.find(el => {return el.id == externalEventType})
        if(res){
          return res.name
        }
      }
      return "TINABA"
    }

    const filterMovements = (rawMovements) => {
      let filteredList = rawMovements;

      if (that.filters.search.terms.length > 0) {
        $log.debug('PosMovementsController', 'filterMovements', 'search terms', that.filters.search.terms);

        const movementIds = [];

        _.forEach(filteredList, movement => {
          let match = true;

          _.forEach(that.filters.search.terms, term => {
            const searchRegexp = new RegExp(`^.*${term}.*$`, 'i');

            if (movement.contactName) {
              if (searchRegexp.test(movement.contactName)) return;
            }

            if (movement.contactSurname) {
              if (searchRegexp.test(movement.contactSurname)) return;
            }

            if (movement.description) {
              if (searchRegexp.test(movement.description)) return;
            }

            match = false;
          });

          if (match) {
            if (movementIds.indexOf(movement.transactionId) === -1) {
              movementIds.push(movement.transactionId);
            }
          }
        });

        filteredList = _.filter(filteredList, movement => movementIds.indexOf(movement.transactionId) > -1);
      }

      return filteredList;
    };

    const loadMovements = () => {
      if (that.loading.movements) return;
      that.loading.movements = true;
      var filterOptions = {};

      if (that.filters.time.value !== 'any' && that.filters.time.value !== 'datepicker') {
        //filterOptions.dateStart = moment().subtract(that.filters.time.value, 'months').format('YYYYMMDD');
        //filterOptions.dateEnd = moment().format('YYYYMMDD');
        filterOptions = NewInstrumentHistoryService.createDefaultRangeOptions(that.filters.time.value, {});
      } else if (that.filters.time.value === 'datepicker') {
        filterOptions.dateEnd = moment(that.end).format('YYYYMMDD');
        filterOptions.dateStart = moment(that.start).format('YYYYMMDD');
      }

      filterOptions.transactionTypes = "PAYMENT_BUSINESS,REFUND";

      if(that.filters.refund){
        filterOptions.hideRefund = 'true';
      }

      if (that.filters.store.value !== 'any') {
        filterOptions.shopId = that.filters.store.value.id;
      }

      filterOptions.page = that.pagination.currentPage.number;
      filterOptions.size = 10;
      filterOptions.sort = "lastModifiedDate,desc"

      if (that.filters.operator.value !== 'any' && that.showDevices) {
          filterOptions.merchantDeviceId = that.filters.operator.value.id;
      }

      if (that.filters.method.value !== 'any') {
        filterOptions.paymentMethods = that.filters.method.value.filter;
      }

      NewInstrumentHistoryService.getTinabaPosHistory(filterOptions).then((movementsResult) => {
        movements = movementsResult.resultList && movementsResult.resultList.length > 0 ? filterMovements(movementsResult.resultList) : [];
        /*movements = movements.sort(function(a, b) {
          a = new Date(a.lastModifiedDate);
          b = new Date(b.lastModifiedDate);
          return a>b ? -1 : a<b ? 1 : 0;
      });*/
      
        that.pagination.currentPage.data = processMovements(movements);
        if (that.setCurrentPageIndex) {
          that.setCurrentPageIndex(movementsResult['pagination']['number']);
        }
        that.setPagesNumber(movementsResult['pagination']['totalPages']);
      }, (reason) => {
        $log.error('DashboardPosMovementsController', 'loadMovements', reason);
      }).finally(() => {
        that.loading.movements = false;
      });
    };

    that.getPdf = (url) => {
      $log.debug('cose da mandare per servizio pdf', url);
      PosService.showPdf(url);
    };

    that.changePage = (page = 0) => {
      if (movements === undefined) {
        loadMovements();
        return;
      }
      that.pagination.currentPage.number = page
      loadMovements();
      //const pageStart = page * PaginationSettings.DEFAULT_PAGE_SIZE;
      //const pageEnd = pageStart + PaginationSettings.DEFAULT_PAGE_SIZE;
    };

    const applyFilters = () => {
      that.pagination.currentPage.number = 0
      if (that.filters.time.value === 'any') {
        that.filters.time.string = $translate.instant('common.any');
      } else if (that.filters.time.value === 'datepicker') {
        that.filters.time.string = `Dal ${$filter('amDateFormat')(that.start, 'DD/MM/YYYY')} al ${$filter('amDateFormat')(that.end, 'DD/MM/YYYY')}`;
      } else {
        that.filters.time.string = `${that.filters.time.value} ${$translate.instant(that.filters.time.value > 1 ? 'common.date.months' : 'common.date.month')}`;
      }

      if (that.filters.operator.value === 'any') {
        that.filters.operator.string = $translate.instant('common.any');
      } else {
        that.filters.operator.string = that.filters.operator.value.name + ' - ' + that.filters.operator.value.id;
      }

      if (that.filters.store.value === 'any') {
        that.filters.store.string = $translate.instant('common.any');
      } else {
        that.filters.store.string = that.filters.store.value.name + ' - ' + that.filters.store.value.id;
      }

      loadMovements();
    };

    that.applyFilters = applyFilters;

    const resetFilters = () => {
      let operators = [];
      if (that.filters && that.filters.operator && that.filters.operator.options.length > 0) {
        operators = that.filters.operator.options;
      }
      let stores = [];
      if (that.filters && that.filters.store && that.filters.store.options.length > 0) {
        stores = that.filters.store.options;
      }
      let methods = [];
      if (that.filters && that.filters.method && that.filters.method.options.length > 0) {
        methods = that.filters.method.options;
      }

      that.filters = {
        time: {
          value: 'any',
          string: $translate.instant('common.any')
        },
        operator: {
          value: 'any',
          string: $translate.instant('common.any'),
          options: operators
        },
        search: {
          terms: [],
          text: ''
        },
        store: {
          value: 'any',
          string: $translate.instant('common.any'),
          options: stores
        },
        method:{
          value: 'any',
          string: $translate.instant('common.any'),
          options: methods
        },
        refund: false
      };
      loadMovements();
    };

    that.exportCsv = () => {
      var filterOptions = {}
      if (that.filters.time.value !== 'any' && that.filters.time.value !== 'datepicker') {
        filterOptions = NewInstrumentHistoryService.createDefaultRangeOptions(that.filters.time.value, {});
      } else if (that.filters.time.value === 'datepicker') {
        filterOptions.dateEnd = moment(that.end).format('YYYYMMDD');
        filterOptions.dateStart = moment(that.start).format('YYYYMMDD');
      }
      PosService.exportCsv(!that.filters.refund, filterOptions.dateStart, filterOptions.dateEnd, that.operator, that.filters.store.value.id, that.filters.operator.value.id);
    };

    that.resetFilters = resetFilters;

    const init = () => {
      this.pageChangedCallback = (index = 0) => {
        that.changePage(index);
      };
      resetFilters();
      loadStores();
      loadCollectionMethods()
      that.changePage();
    };

    that.$onInit = init;

    that.onSearch = loadMovements;

    //const deregMerchantDetailUpdateListener = $rootScope.$on('MERCHANT_DETAIL_UPDATE', loadOperators);
    const deregMerchantDetailFailListener = $rootScope.$on('MERCHANT_DETAIL_FAIL', () => {
      that.loading.operators = false;
    });

    that.$onDestroy = () => {
      deregMerchantDetailUpdateListener();
      deregMerchantDetailFailListener();
    };
  }
}

export default PosMovementsController;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/movements/movements.controller.js
 **/